import { render, staticRenderFns } from "./MitAdminSettingsPage.vue?vue&type=template&id=073adcb5&scoped=true"
import script from "./MitAdminSettingsPage.vue?vue&type=script&lang=js"
export * from "./MitAdminSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./MitAdminSettingsPage.vue?vue&type=style&index=0&id=073adcb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073adcb5",
  null
  
)

export default component.exports